import { useEffect, useState } from "react";
import { getBrowse } from "../utils/itemSearchApi";

// The online ordering page's default (no search typed) view: favourites
// (split by source), AI Menu sections ("From our menu"), and Inventory
// categories (major_category groups, with matching AI Menu items merged
// in server-side). Fetched once per customerId via GET /items/browse.
export default function useOnlineOrderingBrowse(customerId) {
  const [favourites, setFavourites] = useState({ inventory: [], ai_menu: [] });
  const [menuSections, setMenuSections] = useState([]);
  const [categories, setCategories] = useState([]);
  // Starts true when there is a customerId: ItemGridBrowse renders
  // <Skeletons /> while loading, so starting at false would mount
  // BrowseView for one render, fire its /items/all request, then
  // unmount and abort it (a red 'canceled' row in DevTools).
  const [loading, setLoading] = useState(Boolean(customerId));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!customerId) {
      setFavourites({ inventory: [], ai_menu: [] });
      setMenuSections([]);
      setCategories([]);
      return undefined;
    }
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    getBrowse(customerId, { signal: controller.signal })
      .then((result) => {
        setFavourites(result.favourites);
        setMenuSections(result.menuSections);
        setCategories(result.categories);
      })
      .catch((err) => {
        if (err?.name === "CanceledError" || err?.code === "ERR_CANCELED") return;
        setError("Could not load the store's items. Please try again.");
      })
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [customerId]);

  return { favourites, menuSections, categories, loading, error };
}
